<style scoped>
</style>

<template>

<span class="component-wrapper" v-if="flagFetchedNow">
  <span v-tooltip="$t('stat.views')" slot="right">
    <mu-icon value="play_circle_outline" class="inline-icon"/> {{views}}
  </span>
  <span v-tooltip="$t('stat.now')" slot="right">
    <mu-icon value="perm_identity" class="inline-icon"/> {{nowWatching}}
  </span>
</span>

</template>

<script>

// Library
import axios from "axios";

export default {
  name: 'StatPanel',
  props: {
    mediaId: {
      type: String,
      required: true
    },
    type: {
      type: String
    },
    media: {
      type: Object,
      required: true
    },
    currentTime: {
      type: Number,
      required: true
    },
    playlistId: {
      type: String
    }
  },
  data() {
    return {
      // Object
      intervalId: 0,
      nowWatching: 0, // Now watching variable
      views: 0, // View count variable

      // Flag
      flagFetchedNow: false, // Boolean variable for status of fetched now watching
      flagFetchedView: false, // Boolean variable for status of fetched views
    }
  },
  mounted() {
    this.fetchNow();
    this.fetchView();
    this.intervalId = setInterval(this.fetchNow, this.$store.state.auth.intervalFetch); // Set repeatly call function
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  watch: {
    mediaId() {
      this.fetchNow();
      this.fetchView();
    },
  },
  methods: {
    // Fetch
    fetchNow() {
      axios.get(this.$store.getters.urlApi + "view/now/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.nowWatching = response.data.data.count
        this.flagFetchedNow = true;
      });
    },
    fetchView() {
      axios.get(this.$store.getters.urlApi + "view/media/" + this.mediaId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.views = response.data.data.count
        this.flagFetchedView = true;
      });
    },
  },
}
</script>
